import { Spacer } from 'components/layouts/Spacer';
import { Heading3, Paragraph } from 'components/typography';
import React from 'react';
import { NoResultFeedProps } from './NoResultFeed.types';

export const NoResultFeed: React.FC<NoResultFeedProps> = ({ tab }) => {
  return (
    <div className="max-w-[740px] m-auto text-center px-4 py-[60px]">
      <Heading3>Sorry, there are no results in {tab} for this keyword.</Heading3>
      <Spacer height="1rem" />
      <Paragraph size="medium" className="text-center">
        Try searching for something else.
      </Paragraph>
    </div>
  );
};
